import { IBadge } from "../interfaces/models";
import { apiFetch } from "./APIRepository";

export default class BadgeRepository {

    static getAllUserBadges(userID: number): Promise<IBadge[]> {
        if (userID === undefined) {
            userID = -1;
        }
        return apiFetch<IBadge[]>(`/users/achievements/progress/${userID}`);
    }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/repositories/BadgeRepository.ts